<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <p>A data de fundação da(o) <strong>{{razaoSocial}}</strong> é essa mesmo que identificamos aqui?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">    
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="dataFundacao">Data de fundação da empresa</label>
            <input type="text" class="form-control form-control-lg" v-model="dataFundacao" pattern="\d{2}/\d{2}/\d{4}" v-mask="'date'" placeholder="Data de Fundação" required>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary" v-focus>Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const company = this.solicitacao.Empresa
    window.company = company
    return {
      razaoSocial: company ? company.RazaoSocial : null,
      dataFundacao: company ? new Date(company.DataFundacao).toLocaleDateString('pt-BR') : null
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      this.$emit('on-submit', {
        Empresa: {
          DataFundacao: new Date(this.dataFundacao.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1"))
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/FoundingDateStep.vue